<template>
    <div class="address-add">
        <van-nav-bar
                title="添加收货地址"
                left-arrow
                left-text="返回"
                :fixed="isFixed"
                @click-left="back"
        >
        </van-nav-bar>
        <div class="address-add-con">
            <van-address-edit
                    :area-list="areaList"
                    :address-info="addressInfo"
                    show-postal
                    show-delete
                    show-set-default
                    show-search-result
                    :search-result="searchResult"
                    :area-columns-placeholder="['请选择', '请选择', '请选择']"
                    @save="onSave"
                    @delete="onDelete"
                    @change-detail="onChangeDetail"
            />
        </div>
    </div>
</template>

<script>
    import { NavBar,AddressEdit } from 'vant';
    import address from '@/assets/json/address.js'
    import api from '@/api'
    export default {
        name: "index",
        components:{
            [NavBar.name]:NavBar,
            [AddressEdit.name]:AddressEdit,
        },
        data(){
            return{
                isFixed:true,
                areaList:{},
                searchResult:[],
                addressInfo:{},
            }
        },
        mounted(){
            this.areaList = address;

            let res = this.$route.params.item?this.$route.params.item:{};
            if(res.id){
                this.init(res.id);
            }

        },
        methods:{
            async init(id){
                let params = {
                    id:id
                }
                let res = await  api.address.getOneAddress(params);
                if(res){
                    this.addressInfo = res.data;
                    this.addressInfo.isDefault = res.data.defaultStatus

                }
            },
            back(){
                this.$router.go(-1)
            },
            onSave(content) {
               
                
                this.saveData(content)
            },
            async saveData(params){
                let res = await api.address.createAddress(params);
                if(res){
                    this.$router.replace("addressList")
                }
            },
            async onDelete(content) {
                
                let res = await api.address.delAddress(content);
                
                if(res){
                    this.$router.replace("addressList")
                }
            },
            onChangeDetail(val) {
                if (val) {
                    console.log(val)
                } else {
                    this.searchResult = [];
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.address-add{
    .address-add-con{
        padding-top: 46px;

    }

}
.van-button--danger{
    background-color: #1989fa !important;
    border: 1px solid #1989fa;
}
</style>